import React from "react";
import {
  DataGrid as MuiDataGrid,
  DataGridProps as MuiDataGridProps,
  GridColDef,
  GridRowParams,
  GridValidRowModel,
} from "@mui/x-data-grid";
import { Paper, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Index";
import { tokens } from "../../theme";

interface CustomeDataGridProps extends MuiDataGridProps {
  rows: GridValidRowModel[];
  columns: GridColDef[];
  navigateToOnRowClick?: (id: string | number) => string;
}

const CustomeDataGrid: React.FC<CustomeDataGridProps> = ({
  navigateToOnRowClick,
  ...props
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const colors = tokens(theme.palette.mode, reduxTheme);

  const headerBackgroundColor =
    colors.primary[500] || theme.palette.primary.main;
  const rowBackgroundColor = colors.primary[900] || colors.primary[900];
  const headerTextColor = colors.primary[100];

  return (
    <Paper
      sx={{
        boxShadow: 0,
        "@media (min-width: 1024px)": {
          height: "77vh",
        },
        "@media (max-width: 1023px)": {
          height: "auto",
          "& .MuiDataGrid-scrollbar": {
            display: "none",
            width: "0px",
          },
        },
        "& .MuiDataGrid-root": {
          border: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: `${headerBackgroundColor} !important`,
          borderBottom: "none",
          color: colors.primary[100] || colors.primary[700],
        },
        "& .MuiDataGrid-columnHeader": {
          padding: "16px",
          backgroundColor: `${headerBackgroundColor} !important`,
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: headerTextColor,
          fontWeight: "bold",
        },
        "& .MuiDataGrid-row": {
          cursor: "pointer",
          backgroundColor: rowBackgroundColor,
        },
        "& .MuiDataGrid-cell:focus": {
          outline: "none",
        },
        "& .MuiDataGrid-footerContainer": {
          backgroundColor: colors.primary[900],
          justifyContent: "center",
          padding: 1,
        },
      }}
    >
      <MuiDataGrid
        onRowClick={(params: GridRowParams) => {
          if (navigateToOnRowClick) {
            navigate(navigateToOnRowClick(params.row.id));
          }
        }}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        {...props}
      />
    </Paper>
  );
};

export default CustomeDataGrid;
